/**
 * Skrypt obsługujący dynamiczne wyszukiwanie i filtrowanie publikacji na żywo.
 */

function initPublicationsSearch() {
  const searchInput = document.querySelector('.js-publications-search');
  const items = document.querySelectorAll('.js-publication-item');
  const emptyState = document.querySelector('.js-publications-empty');
  const countDisplay = document.querySelector('.js-publications-count');
  const clearButton = document.querySelector('.js-publications-clear');
  const paginationWrapper = document.querySelector(
    '.js-publications-pagination',
  );

  if (!searchInput || !items.length) {
    return;
  }

  const totalItems = items.length;

  const updateVisibility = (query) => {
    const cleanQuery = query.trim().toLowerCase();
    let visibleCount = 0;

    items.forEach((item) => {
      const title = (
        item.getAttribute('data-title') ||
        item.textContent ||
        ''
      ).toLowerCase();
      const isMatch = !cleanQuery || title.includes(cleanQuery);

      if (isMatch) {
        item.classList.remove('publications-archive__item--hidden');
        visibleCount++;
      } else {
        item.classList.add('publications-archive__item--hidden');
      }
    });

    // Update clear button visibility
    if (clearButton) {
      if (cleanQuery.length > 0) {
        clearButton.classList.add(
          'publications-archive__search-clear--visible',
        );
      } else {
        clearButton.classList.remove(
          'publications-archive__search-clear--visible',
        );
      }
    }

    // Update empty state
    if (emptyState) {
      if (visibleCount === 0) {
        emptyState.classList.remove('publications-archive__empty--hidden');
      } else {
        emptyState.classList.add('publications-archive__empty--hidden');
      }
    }

    // Update count display
    if (countDisplay) {
      if (cleanQuery.length > 0) {
        countDisplay.textContent = `Wyświetlono: ${visibleCount} z ${totalItems}`;
      } else {
        const defaultText = countDisplay.getAttribute('data-default-text');
        if (defaultText) {
          countDisplay.textContent = defaultText;
        }
      }
    }

    // When actively filtering on client side, hide static page pagination
    if (paginationWrapper) {
      if (cleanQuery.length > 0) {
        paginationWrapper.style.display = 'none';
      } else {
        paginationWrapper.style.display = '';
      }
    }
  };

  searchInput.addEventListener('input', (e) => {
    updateVisibility(e.target.value);
  });

  if (clearButton) {
    clearButton.addEventListener('click', () => {
      searchInput.value = '';
      searchInput.focus();
      updateVisibility('');
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initPublicationsSearch();
});
